import { render } from "./MTextArea.vue?vue&type=template&id=29dba1a1&scoped=true"
import script from "./MTextArea.vue?vue&type=script&lang=js"
export * from "./MTextArea.vue?vue&type=script&lang=js"

import "./MTextArea.vue?vue&type=style&index=0&id=29dba1a1&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dba1a1"]])

export default __exports__